import type React from 'react'

import css from './styles.module.css'

export const AvatarInfo: React.FC = () => {
  return (
    <div className={css.avatar_info}>
      <span className={css.label}>Avatar</span>
      <span className={css.description}>PNG, JPG or JPEG image, 5 MB max.</span>
      <span className={css.description}>Recommended size is 256×256px.</span>
    </div>
  )
}
